import React from 'react'
import { PageProps } from 'gatsby'

// Lazy loading
import loadable from '@loadable/component'

export interface LocationsProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Locations
  location: PageProps['location']
}

interface PostProps {
  [key: string]: any
}

const LocationsShell: React.FC<LocationsProps> = ({ fields, location }) => {
  const types: PostProps = {
    default: loadable(() => import('components/flex/Locations/Locations')),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default LocationsShell
